import { parseBool } from "hub/src/utils/parseBool";

//Its okay this is not using the VITE_ prefix because in the vite.config.ts file
// we are defining process.env.REACT_APP_PILLAR_API_URL to use the ENV there so it can be used in the client code
export const ENV = {
  REACT_BASE_PATH: window.REACT_BASE_PATH,
  REACT_APP_PILLAR_API_URL:
    window.REACT_APP_PILLAR_API_URL || process.env.REACT_APP_PILLAR_API_URL,
  REACT_APP_SOCIETY_ID:
    window.REACT_APP_SOCIETY_ID || process.env.REACT_APP_SOCIETY_ID,
  REACT_APP_HIDE_SIDEBAR: parseBool(
    process.env.REACT_APP_HIDE_SIDEBAR,
    window.REACT_APP_HIDE_SIDEBAR,
  ),
  REACT_APP_IFRAME_SSO_REDIRECT_URL:
    process.env.REACT_APP_IFRAME_SSO_REDIRECT_URL ||
    window.REACT_APP_IFRAME_SSO_REDIRECT_URL,
  REACT_APP_IFRAME_SSO_PATH:
    process.env.REACT_APP_IFRAME_SSO_PATH || window.REACT_APP_IFRAME_SSO_PATH,
} as const;
